import { attr, controller, targets } from "@github/catalyst";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let TabNavItemElement = class extends HTMLElement {
  constructor() {
    super(...arguments);
    this.key = "";
    this.active = false;
    this.targets = "tab-nav.items";
    this.action = "click:tab-nav#navigateToTab keydown:tab-nav#navigateToTab";
  }
  connectedCallback() {
    this.tabIndex = 0;
    this.setAttribute("role", "tab");
  }
  attributeChangedCallback(name) {
    if (name === "data-active") {
      this.setAttribute("aria-selected", this.active.toString());
    }
  }
};
__decorateClass([
  attr
], TabNavItemElement.prototype, "key", 2);
__decorateClass([
  attr
], TabNavItemElement.prototype, "active", 2);
__decorateClass([
  attr
], TabNavItemElement.prototype, "targets", 2);
__decorateClass([
  attr
], TabNavItemElement.prototype, "action", 2);
TabNavItemElement = __decorateClass([
  controller
], TabNavItemElement);
let TabNavElement = class extends HTMLElement {
  constructor() {
    super(...arguments);
    this.activeKey = "";
  }
  connectedCallback() {
    const observer = new MutationObserver(() => {
      if (!this.hasActiveItem && this.items[0] && this.panels[0]) {
        this.activeKey = this.items[0].key;
        observer.disconnect();
      }
    });
    observer.observe(this, { childList: true, subtree: true });
  }
  attributeChangedCallback(name, _oldValue, newValue) {
    if (name === "data-active-key" && newValue) {
      if (this.activeItem && this.activePanel) {
        this.activeItem.active = false;
        this.activePanel.active = false;
      }
      this.getItem(this.activeKey).active = true;
      this.getPanel(this.activeKey).active = true;
    }
  }
  navigateToTab(event) {
    if ("key" in event && ![" ", "Enter"].includes(event.key))
      return;
    event.preventDefault();
    if (event.target instanceof TabNavItemElement) {
      this.activeKey = event.target.key;
    }
  }
  getItem(key) {
    const matchingItem = this.items.find((item) => item.key === key);
    if (matchingItem)
      return matchingItem;
    throw new Error(`No matching item found: ${key}`);
  }
  getPanel(key) {
    const matchingPanel = this.panels.find((panel) => panel.key === key);
    if (matchingPanel)
      return matchingPanel;
    throw new Error(`No matching panel found: ${key}`);
  }
  get hasActiveItem() {
    return this.items.some((item) => item.active);
  }
  get activeItem() {
    return this.items.find((item) => item.active);
  }
  get activePanel() {
    return this.panels.find((panel) => panel.active);
  }
};
__decorateClass([
  attr
], TabNavElement.prototype, "activeKey", 2);
__decorateClass([
  targets
], TabNavElement.prototype, "items", 2);
__decorateClass([
  targets
], TabNavElement.prototype, "panels", 2);
TabNavElement = __decorateClass([
  controller
], TabNavElement);
let TabNavPanelElement = class extends HTMLElement {
  constructor() {
    super(...arguments);
    this.key = "";
    this.active = false;
    this.targets = "tab-nav.panels";
  }
  connectedCallback() {
    this.setAttribute("role", "tabpanel");
    this.setAttribute("aria-labelledby", this.key);
  }
};
__decorateClass([
  attr
], TabNavPanelElement.prototype, "key", 2);
__decorateClass([
  attr
], TabNavPanelElement.prototype, "active", 2);
__decorateClass([
  attr
], TabNavPanelElement.prototype, "targets", 2);
TabNavPanelElement = __decorateClass([
  controller
], TabNavPanelElement);
//# sourceMappingURL=style-closet-elements.mjs.map
